module.exports = __webpack_public_path__ + "img/11.d01ea880.jpg";